import React, { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";
import MainWrapper from "../layouts/MainWrapper";
import CardWrapper from "../layouts/CardWrapper";
import PageTitle from "../components/PageTitle";
import CustomBreadcrumb from "../components/CustomBreadcrumb";
import Tabs from "../components/Tabs/Tabs";
import JSZip from "jszip";
import { saveAs } from "file-saver";

const downloadAll = async (fileUrls = [], setProgress, id) => {
  if (!fileUrls.length) return;

  // 🟢 Case: Single file – download directly
  if (fileUrls.length === 1) {
    const url = fileUrls[0];
    const filename = decodeURIComponent(url.split('/').pop().split('?')[0]);

    try {
      setProgress?.(10);
      const response = await fetch(url, { mode: "cors" });
      const blob = await response.blob();
      setProgress?.(100);
      saveAs(blob, filename);
    } catch (error) {
      console.error(`Failed to download ${filename}:`, error);
      setProgress?.(0);
    }
    return;
  }

  // 🟡 Case: Multiple files – fetch in parallel and zip
  const zip = new JSZip();

  try {
    setProgress?.(10);

    // Fetch all files in parallel
    const fileFetchPromises = fileUrls.map(async (url) => {
      const filename = decodeURIComponent(url.split('/').pop().split('?')[0]);

      try {
        const response = await fetch(url, { method: "GET", mode: "cors" });
        const blob = await response.blob();
        return { filename, blob };
      } catch (error) {
        console.error(`Failed to fetch ${filename}:`, error);
        return null;
      }
    });

    const fileBlobs = await Promise.all(fileFetchPromises);

    fileBlobs.forEach((file) => {
      if (file) zip.file(file.filename, file.blob);
    });

    // Update progress before starting zip
    setProgress?.(60);

    const zipBlob = await zip.generateAsync(
      { type: "blob" },
      (metadata) => {
        const percent = Math.floor(60 + (metadata.percent * 0.4)); // zip phase: 60–100%
        setProgress?.(percent);
      }
    );

    saveAs(zipBlob, `${id}.zip`);
    setProgress?.(100);
  } catch (zipError) {
    console.error("Error generating zip:", zipError);
    setProgress?.(0);
  }
};


const formatDate = (date) => {
  if (!date) return "From - To Date";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const year = date.getFullYear();

  return `${month}-${day}-${year}`;
};

const messageTypeMap = {
  docs: [6, 7],
  images: [3],
  audio: [5],
  video: [4, 8],
  all: []
};


const AllFile = ({files, setShowFilesView, conversationId, chatFilesTotal}) => {

  console.log("files", files)
  const [activeTab, setActiveTab] = useState("all");
  const [filesShow, setFilesShow] = useState([]);
  const [filterByName, setFilterByName] = useState("");

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [progress, setProgress] = useState("");


  const handleCheckboxChange = (fileId) => {
    setSelectedFiles((prev) =>
      prev.includes(fileId) ? prev.filter(id => id !== fileId) : [...prev, fileId]
    );

    console.log("selectChange",selectedFiles.includes(fileId) ? selectedFiles.filter(id => id !== fileId) : [...selectedFiles, fileId])
  };


  const handleDownloadAllFiles = () => {
    downloadAll(files?.map(e=>e.message), setProgress, conversationId?.id);

  }

  const handleDownloadSelectedFiles = () => {

    console.log("filesToDownload",selectedFiles)
    downloadAll(selectedFiles, setProgress, conversationId?.id);

  }
  const handleSelectAllFiles = () => {
    let type;

    const filesToDownload = filesShow?.map(e => e.message);
    console.log("filesToDownload", filesToDownload)
    setSelectedFiles(filesToDownload);

  }

  const filterFilesByName = () => {
    const search = filterByName.trim().toLowerCase();
    if (search.length == 0) return files; // Return full list if search is empty
    setFilesShow(files?.filter(file => {
      const nameOnly = file.name.toLowerCase();
      return nameOnly.includes(search);
    }));
  }


  const getFilteredFiles = (files, filterValue, activeTab) => {
    console.log("files",files)
    const search = filterValue.trim().toLowerCase();

    return files?.filter(file => {
      const nameOnly = file.name.split("/").pop().toLowerCase();
      const matchesSearch = nameOnly.includes(search);
      const matchesTab = activeTab === "all" || messageTypeMap[activeTab]?.includes(file.message_type);

      return matchesTab && matchesSearch;
    });
  };
  

  // useEffect(() => {
  //   const filtered = getFilteredFiles(files, filterByName, activeTab);
  //   setFilesShow(filtered);
  // }, [activeTab, files]); // no need for filterByName if handled in onChange
  

  useEffect(() => {
    setFilesShow(null);
    const filtered = getFilteredFiles(files, filterByName, activeTab);
    console.log("filtered", filtered);;
    setFilesShow(filtered);
  }, [filterByName, activeTab, files]);

  const BeadcrumbItems = [
    { label: "History", onClick: () => setShowFilesView(false)},
    { label: "All Files", active: true },
  ];

  // const tabItem = ["All", "Chats", "Docs", "Images", "Video"];
  const tabItem = { All: "all", Audio: "audio", Docs: "docs", Images:"images", Video: "video" };
  // File data array
  console.log("sssss", files)
  return (
    <>
      <Row className="align-items-end justify-content-between mb-4">
        <Col sm="7">
          <CustomBreadcrumb items={BeadcrumbItems} />
          <PageTitle title="All Files" />
        </Col>
        <Col sm="5" className="text-end">
          <Button
            as="button"
            onClick={handleDownloadAllFiles}
            variant="primary"
            className="btn-md d-inline-flex align-items-center gap-1"
          >
            <Image
              src="/images/download-white.svg"
              width={18}
              height={18}
              alt="Download White Icon"
            />
            Download All
          </Button>
        </Col>
      </Row>
      <MainWrapper>
        <CardWrapper className="full-box-0">
          {selectedFiles?.length > 0 && <div className="bg-blue-100 p-3 rounded-3 d-md-flex align-items-md-center justify-content-md-between mb-4">
            <div className="d-flex align-items-center gap-4 mb-3 mb-md-0">
              <Button
                as="button"
                variant="white"
                onClick={handleSelectAllFiles}
                className="btn-md border-0 shadow-none text-blue"
              >
                Select All
              </Button>
              <p className="fs-18 fw-semibold mb-0">{selectedFiles?.length} {(selectedFiles.length > 1)?"items":"item"} selected</p>
            </div>

            <Button
              as="button"
              variant="primary"
              onClick={handleDownloadSelectedFiles}
              className="btn-md d-flex align-items-center gap-1"
            >
              <Image
                src="/images/download-white.svg"
                width={18}
                height={18}
                alt="Download White Icon"
              />
              Download Selected
            </Button>
          </div>}
          <Row className="align-items-center gy-4 gy-xxl-0 mb-4">
            <Col xxl="4">
              <div className="d-flex align-items-center gap-3">
                <Button
                  onClick={()=>setShowFilesView(false)}
                  variant="white"
                  as="a"
                  // href="/history"
                  className="btn-md d-inline-flex align-items-center gap-2"
                >
                  <Image
                    src="/images/caret-left.svg"
                    width={18}
                    height={18}
                    alt="Caret Left Icon"
                  />{" "}
                  Back
                </Button>
                <h2 className="fs-5 fw-semibold text-gray-800 mb-0">
                  All Type Files {files.length ?? ''}
                </h2>
              </div>
            </Col>
            <Col className="flex-grow-1 text-xxl-end">
              {/* <Tabs tabItem={tabItem} /> */}
              <Tabs tabItem={tabItem} changeFunction={setActiveTab}  />
            </Col>
            <Col xxl="3" lg="5" className="text-end">
              <input
                type="text"
                value={filterByName}
                onChange={(e) => {
                  const value = e.target.value;
                  setFilterByName(value);

                  const filtered = getFilteredFiles(files, value, activeTab);
                  setFilesShow(filtered);
                }}

                name="search"
                className="form-control form-control-search"
                aria-label="Search Input"
                placeholder="Search here.."
                autoComplete="off"
              />
            </Col>
          </Row>
          <Row className="gy-3 gy-lg-4 gx-3 gx-lg-4">
            {filesShow?.map((file, idx) => {
              const isChecked = selectedFiles.some((element) => element === file.message); // assuming `element.id` is unique

              return <Col xxl="3" lg="4" md="6" key={file.id}>
                <div className="file-info-box">
                  <div className="file-info-box-body">
                    <div className="d-flex align-items-start justify-content-between gap-2">
                      {/* {messageTypeMap["video"].includes(file.message_type) && <div className="position-relative">
                        <Image className='position-absolute top-50 start-50 translate-middle pe-none z-1' src="images/play-rounded.svg" width={24} height={24} alt='Play Icon' />
                        <VideoPopupLightbox 
                          className="ratio ratio-1x1"
                          videoSlide={{
                            type: 'video',
                            sources: [
                                {
                                  src: file?.message,
                                  type: 'video/mp4',
                                },
                              ],
                          }}
                        >
                          <video className="bg-gray-100 object-fit-contain rounded-1" muted pui>
                            <source
                              src={file?.message}
                              type="video/mp4"
                              allowFullScreen
                            />
                          </video>
                        </VideoPopupLightbox>
                      </div>} */}
                      {messageTypeMap["images"].includes(file.message_type) && <Image
                          className="rounded-3 object-fit-cover"
                          src={file?.message || "/images/image-placeholder.jpg"}
                          width={64}
                          height={64}
                        alt="File"
                      />}
                      {messageTypeMap["docs"].includes(file.message_type) && <Image
                        src={"/images/file-type-icon-doc.svg"}
                          width={64}
                          height={64}
                        alt="Icon"
                      />}
                      {messageTypeMap["audio"].includes(file.message_type) && <Image
                        src={"/images/file-type-icon-audio.svg"}
                          width={64}
                          height={64}
                        alt="Icon"
                      />}
                      {messageTypeMap["video"].includes(file.message_type) && <Image
                        src={"/images/file-type-icon-video.svg"}
                          width={64}
                          height={64}
                        alt="Icon"
                      />}
                      <div className="d-flex align-items-start gap-2">
                        <span className={`badge ${file.badge.className}`}>
                          {file.badge.text}
                        </span>
                        <label
                          className="form-check-label align-items-center"
                          htmlFor={`file${file.id}`}
                        >
                          <input
                            className="form-check-input mt-1"
                            id={`file${file.id}`}
                            type="checkbox"
                            checked={isChecked}
                            onChange={() => handleCheckboxChange(file.message)}
                          />
                        </label>
                      </div>
                    </div>
                    <h3 className="fs-14 fw-medium text-gray-800 mb-0 mt-3">
                      {file.name}
                    </h3>
                    <ul className="d-md-flex align-items-md-center gap-2 list-unstyled mt-2 mb-0">
                      <li className="fs-12 fw-medium text-gray-500">
                        {formatDate(new Date(file.created_date))}
                      </li>
                      <li className="dot-separator"></li>
                      <li className="fs-12 fw-medium text-gray-500">
                        {file.owner}
                      </li>
                    </ul>
                  </div>
                </div>
              </Col>
            })}
          </Row>
        </CardWrapper>
      </MainWrapper>
    </>
  );
};

export default AllFile;
